<div class="recent results">
  <div class="recent-header">
    Recent <a tabindex="0" role="button" class="recent-clear">Clear</a>
  </div>
  <ul>
    <% _.each(doctors, function(group) { %>
      <li class="result" data-search-url="<%= group.url%>" <% if (group.isSearchQuery) { %> data-search-query="true"<% } %>>
        <div class="thumbnail" style="background-image: url(<%= group.image_url %>)"></div>
        <div class="details">
          <p class="name"><%= group.label %></p>
          <p class="meta"></p>
        </div>
      </li>
    <% }) %>
  </ul>
</div>
